import UAParser from 'ua-parser-js';
import { v4 as uuidv4 } from 'uuid';

import config from '../../config';
import { isRunningTests } from '../isRunningTests';

const deviceIdKey = 'deviceId';
const APP_SESSION_ID_KEY = 'APP_SESSION_ID_KEY';

const parser = new UAParser();

export const getBrowser = parser.getBrowser();
export const getOS: { name: string | undefined; version: string | undefined } = parser.getOS();
export const getDevice: {
  model: string | undefined;
  type: string | undefined;
  vendor: string | undefined;
} = parser.getDevice();

export const isChrome = getBrowser.name === 'Chrome';
export const isSafari = getBrowser.name === 'Safari';
export const isMobileSafari = getBrowser.name === 'Mobile Safari';
export const isIOS = getOS.name === 'iOS';
export const isAndroid = getOS.name === 'Android';
export const isMobile = isIOS || isAndroid;
// iPadOS Safari sends a Mac user agent by default (and a Mac one with a Mobile token in some layouts),
// so the parser cannot tell an iPad from a Mac. Macs have no touch screen; every iPad reports touch points.
export const isIpad = getOS.name === 'Mac OS' && navigator.maxTouchPoints > 0;
export const isHeadlessChrome = getBrowser.name === 'Chrome Headless';
export const isRendertron = isHeadlessChrome || Boolean(localStorage['pretend-rendertron']);
export const isFirefox = getBrowser.name === 'Firefox';
export const isSmartTV = getDevice.type === 'smarttv';
const isSamsungTV = Boolean(getOS.name?.toLowerCase().startsWith('tizen')) && isSmartTV;
const isLGTV = getOS.name === 'webOS' && isSmartTV;
// the TV apps require Tizen 3 and webOS 6 (Chromium 79) respectively.
// See device.utils.test.ts for the user agents all of this is checked against.
export const isSupportedSamsungTV = isSamsungTV && Number(getOS.version?.split('.')[0]) >= 3;
export const isSupportedLGTV = isLGTV && Number(getBrowser.version?.split('.')[0]) >= 79;

export const getAppSessionId = () => {
  let id = sessionStorage.getItem(APP_SESSION_ID_KEY);

  if (id === null) {
    id = uuidv4();
    sessionStorage.setItem(APP_SESSION_ID_KEY, id);
  }

  return id;
};

export const getDeviceId = () => {
  let id = localStorage.getItem(deviceIdKey);

  if (id === null) {
    id = uuidv4();
    localStorage.setItem(deviceIdKey, id);
  }

  return id;
};

// JSDOM does not support matchMedia
export const isTouchDevice = isRunningTests() ? false : window.matchMedia('(pointer:coarse)').matches;

export const isMobileTouchDevice = (isIOS || isAndroid) && isTouchDevice;

export const getAppLink = () => {
  if (isAndroid) {
    return config.androidApp.link;
  }
  if (isIOS || isIpad) {
    return config.iosApp.link;
  }
  return '';
};
